module.exports = __webpack_public_path__ + "img/Artificial_intelligence_illustrator.69f99a5e.svg";